import { create } from 'zustand';

/**
 * Estado do aceite pendente — REQ-012 Adendo / AB#63.
 *
 * Populado pelo interceptor de `apiFetch` quando o backend retorna 403 com
 * `code='ACEITE_PENDENTE'`. O `AceitePendenteModal` lê esse store e abre o
 * modal bloqueante. Limpo após o usuário aceitar ou sair.
 */

interface PendenteInfo {
  documento_id: number;
  tipo: string;
  versao: string;
}

interface State {
  pendente: PendenteInfo | null;
  setPendente: (p: PendenteInfo) => void;
  limpar: () => void;
}

export const useAceitePendenteStore = create<State>((set) => ({
  pendente: null,
  setPendente: (p) => set({ pendente: p }),
  limpar: () => set({ pendente: null }),
}));
